import { getPhotosForPhotowall } from 'entities/photos';

/*-------------------------------------------------------------------------------*/
/* CAROUSEL WIDGET

This is the master controller file for our “carousel” type widgets, which use slider navigation functionality.

Currently this is:
  - Photowall (2 or 3 rows)
  - Mosaic (2 or 3 rows)

In the future we would like to also migrate:
  - Horizontal widget (horizontal.js points to related files)
  - Vertical widget (vertical.js points to related files)
  - Coverflow widget (coverflow.js points to related files)
  - Slideshow widget (slideshow.js points to related files)

It services all device types (desktop/tablet/mobile). Any specifically targetted device functionality should be placed
within this file using "options.isMobile" to make the decision. Any functionality which will take up a lot of space should
be made in a new view file titled carousel_controller_mobile.js which extends the base controller below, NOT duplicating
its code but inheriting from it.

There are 2 collections managed by this controller:

-containerCollection: The backbone collection which corresponds to each swiper "slide"
-photosCollection: The backbone collection which holds each individual photo. These are fed into individual regions
within each Swiper "slide". Each slide may contain multiple photos, depending on the layout

Any Widget with an AlbumDistill type of "carousel" will use this controller. The decision of which "type" of carousel
will be rendered lives in the displayOptions property "carouselOptions.layout". This lets us easily add new subtypes
without having to create new files or altering the albumDistill DB. any subtypes will simply alter Swiper's properties.
*/
/*-------------------------------------------------------------------------------*/
Pixlee.module('CarouselApp', function(CarouselApp, App, Backbone, Marionette, $) {
    CarouselApp.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            //initialize controller instance values
            this.displayOptions = options.display_options;

            //initialize swiper slide collection and individual photo collections
            this.containerCollection = new Backbone.Collection();
            this.photosCollection = getPhotosForPhotowall(false);
            this.photosCollection.on({
                'sync': this.handleFetchPhotos.bind(this),
                'reset': this.resetContainerCollection.bind(this)
            });

            //initialize all views
            var layout = new CarouselApp.Layout({
                collection: this.photosCollection,
                displayOptions: this.displayOptions
            });

            var headerView = new CarouselApp.HeaderView({
                model: App.currentAlbum
            });

            var carouselContainer = new CarouselApp.CarouselContainer({
                photosCollection: this.photosCollection,
                collection: this.containerCollection,
                displayOptions: this.displayOptions
            });

            //set listeners
            this.listenTo(carouselContainer, 'child:add:next:container', this.addNextContainer);

            //render individual views
            this.show(layout);
            layout.carouselWidget.show(carouselContainer);
            layout.widgetHeaderRegion.show(headerView);

            //for interactive widget we want to fetch proper platform view (since this controller is shared)
            if (_.isTruthy(this.displayOptions.is_interactive)) {
                var socialHubView = '';
                if (_.isTruthy(options.isMobile)) {
                    socialHubView = 'get:navbar:mobile:view';
                } else {
                    socialHubView = 'get:navbar:view';
                }
                layout.interactiveRegion.show(App.request(socialHubView, options, this.photosCollection));
            }

        },
        //on fetch we want to properly handle filling a new slide or adding to the current one
        handleFetchPhotos: function() {
            // Prepend the Header Tile if is the chosen layout
            if (this.displayOptions.headerOptions.layout === 'tile') {
                this.prependHeaderTile();
            }
            if (!this.photosCollection.length) {
                return;
            }
            if (this.containerCollection.length) {
                var lastContainer = this.containerCollection.last();
                lastContainer.trigger('fill:regions');
            } else {
                this.addNextContainer();
            }
        },
        //reset the Swiper slide collection (mainly for interactive widget)
        resetContainerCollection: function() {
            this.containerCollection.reset();
            // we can potentially reset a collection with a bunch of photos => initialize containers IFF there's photos
            if (this.photosCollection.length) {
                this.handleFetchPhotos();
            }
        },
        //Append a new container to the Swiper slide queue
        addNextContainer: function() {
            var container = new Backbone.Collection();
            this.containerCollection.add(container);
        },
        //Special case for uploader tile, add it to the very start (if that's the setting)
        prependHeaderTile: function() {
            var headerUploaderTile = new Backbone.Model({
                isUploaderTile: true,
                uploaderTileType: 'front'
            });
            if (_.isFalsy(this.photosCollection.findWhere(headerUploaderTile.attributes))) {
                this.photosCollection.unshift(headerUploaderTile);
            }
        }
    });

});
